export default "__VITE_ASSET__CVhaSyym__"